import React from 'react';
import CategoryLandingTemplate from '../../components/CategoryLandingTemplate';
import tecnalData from '../../data/tecnal';

const AlimentacionAnimalPage = () => {
  return <CategoryLandingTemplate data={tecnalData['alimentacion-animal']} />;
};

export default AlimentacionAnimalPage;
